import { Map, fromJS } from "immutable";
import moment from "moment";
import {
  FETCH_USER_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATION_SUCCESS,
  ADD_CONVERSATION_MESSAGE_SUCCESS,
  MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM,
  EDIT_USER_CONVERSATION_SUCCESS,
  MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING,
} from "~/store/action_types";

const user_conversation = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_CONVERSATION_SUCCESS: {
      return state.merge(Map({ new_messages_since: moment().unix() }));
    }
    case ADD_CONVERSATION_MESSAGE_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { conversation_messages = {} } = entities;
      const { single } = result;
      const message = conversation_messages[single];

      if (message && message.created_on) {
        return state.merge(Map({ new_messages_since: Number(message.created_on) }));
      }

      return state;
    }
    case EDIT_USER_CONVERSATION_SUCCESS:
    case MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { user_conversations = {} } = entities;
      const { single } = result;

      const userConversation = user_conversations[single];

      if (userConversation) {
        return state.merge(Map({ ...userConversation }));
      }
      return state;
    }
    case MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING: {
      const { messageCreatedOn } = action;

      if (messageCreatedOn > 0) {
        return state.set("new_messages_since", messageCreatedOn);
      }

      return state;
    }
    default:
      return state;
  }
};

const user_conversations = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_USER_CONVERSATIONS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { user_conversations = [] } = entities;
      return state.merge(fromJS(user_conversations));
    }
    case FETCH_CONVERSATION_SUCCESS: {
      const { id } = action;
      if (id > 0) {
        return state.set(`${id}`, user_conversation(state.get(`${id}`), action));
      }
      return state;
    }
    case ADD_CONVERSATION_MESSAGE_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { conversation_messages = {} } = entities;
      const { single } = result;

      const message = conversation_messages[single];
      const conversationId = message && message.conversation_id ? message.conversation_id : 0;

      if (conversationId > 0) {
        return state.set(`${conversationId}`, user_conversation(state.get(`${conversationId}`), action));
      }

      return state;
    }
    case EDIT_USER_CONVERSATION_SUCCESS:
    case MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: conversationId } = result;

      if (conversationId > 0) {
        return state.set(`${conversationId}`, user_conversation(state.get(`${conversationId}`), action));
      }
      return state;
    }
    case MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING: {
      const { conversationId } = action;

      if (conversationId > 0) {
        return state.set(`${conversationId}`, user_conversation(state.get(`${conversationId}`), action));
      }
      return state;
    }
    default:
      return state;
  }
};

export default user_conversations;
